import pl from './pl'
import ee from './ee'
import lt from './lt'
import eeru from './ee-ru'
import lv from './lv'
import lvru from './lv-ru'
import ua from './ua'

const messages = {
    pl,
    ee,
    lt,
    eeru,
    lv,
    lvru,
    ua
}

export default messages
